import { createRef, Component } from 'react';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';

import { PricingCards } from '../../../../../../data/realTimeApi';

import PricingPlansCardHeader from '../PricingPlansCard/PricingPlansCardHeader';
import PricingPlansCardContent from '../PricingPlansCard/PricingPlansCardContent';
import PricingForm from '../../PricingForm';
import PricingPlansFilterLayoutButton from '../PricingPlansFilter/PricingPlansFilterLayout';
import PricingPlansColumnLayout from '../PricingPlansColumnLayout';
import Slider from '../../../../../Shared/ReactSlick';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './style.module.scss';

const cx = classNames.bind(Styles);
export class PricingPlansOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLayoutTab: 'column',
      currentSlide: null,
    };
    this.slickRef = createRef();
    this.handleLayoutChange = this.handleLayoutChange.bind(this);

    this.settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendDots: (dots) => (
        <div style={{
          bottom: 0,
          zIndex: 100,
          top: '100px',
          height: 0,
        }}
        >
          <ul style={{ margin: '0px' }}>
            {' '}
            {dots}
            {' '}
          </ul>
        </div>
      ),
      afterChange: (slide) => {
        this.setState({
          currentSlide: slide,
        });
      },
    };
  }

  componentDidMount() {
    const {
      title, activePlanTab,
    } = this.props;
    const slideIndex = PricingCards.filter(
      (item) => item.planType === activePlanTab,
    ).map((card) => card.header.title).indexOf(title);

    this.setState({
      currentSlide: slideIndex,
    });

    this.slickRef.current.slickGoTo(slideIndex);
  }

  handleLayoutChange = (id) => {
    this.setState({
      activeLayoutTab: id,
    });
  };

  render() {
    const {
      showOverlay, hideOverlay, activePlanTab,
    } = this.props;

    const { activeLayoutTab, currentSlide } = this.state;

    return (
      <div
        className={cx('PricingPlansCard__overlay', {
          show: showOverlay,
        })}
        id="mobile_overlay"
      >
        <div className={cx('Overlay__title')} onClick={hideOverlay}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <span>Plans</span>
        </div>

        <div className={cx('PricingPlans__filter_view')}>
          <span className={cx('PricingPlans__filter_view__title')}>Layout:</span>
          <div className={cx('PricingPlans__filter--btn')}>
            <PricingPlansFilterLayoutButton
              btnID="detailed"
              btnText="Detailed"
              isActive={activeLayoutTab === 'detailed'}
              handleBtnClick={this.handleLayoutChange}
            />
            <PricingPlansFilterLayoutButton
              btnID="column"
              btnText="Column"
              isActive={activeLayoutTab === 'column'}
              handleBtnClick={this.handleLayoutChange}
            />
          </div>
        </div>

        <Slider
          ref={this.slickRef}
          {...this.settings}
          className={cx({ [`${activePlanTab}-${currentSlide}`]: true })}
        >
          {
            PricingCards.filter(
              (item) => item.planType === activePlanTab,
            ).map((card) => (

              <div key={card.header.title}>
                <PricingPlansCardHeader
                  logo={card.logo}
                  title={card.header.title}
                  priceMonthly={card.header.priceMonthly}
                  priceAnnually={card.header.priceAnnually}
                  free={card.header.free}
                  comingSoon={card.header.comingSoon}
                  contactUs={card.header.contactUs}
                  contactUsForPrice={card.header.contactUsForPrice}
                  fromOverlay
                  isQuarterly={card.header.isQuarterly}
                />
                {activeLayoutTab === 'detailed' && (
                  <PricingPlansCardContent
                    content={card.contentMobile}
                    priceMonthly={card.header.priceMonthly}
                    priceAnnually={card.header.priceAnnually}
                    isQuarterly={card.header.isQuarterly}
                  />
                )}
                {activeLayoutTab === 'column' && <PricingPlansColumnLayout content={card.tableContentMobile} />}
                <div className={cx('contactSection', { [`${activeLayoutTab}`]: activeLayoutTab && !card.header.isArchive })}>
                  {(card.header.isArchive && activeLayoutTab === 'column') && (
                    <div className={cx('terms')}>
                      * Full Archive - from 1 Jan 2018 onward
                    </div>
                  )}
                  <div className={cx('Overlay__form')} id="overlay_contactus_form">
                    <span className={cx('Overlay__form--title')}>Contact Us</span>
                    <PricingForm />
                  </div>
                </div>
              </div>

            ))
          }
        </Slider>
      </div>
    );
  }
}

export default withComponentName(PricingPlansOverlay);
